import { NavLink, useLocation } from "react-router-dom";
import { ADMIN_PATH } from "../../config/adminPath";

/* ── Retail (B2C) workspace menu ── */
const RETAIL_NAV = [
  { section: null,         items: [
    { to: "/dashboard",            icon: "📊", label: "Dashboard"         },
    { to: "/orders",               icon: "📦", label: "Orders"            },
  ]},
  { section: "Store",      items: [
    { to: "/products",             icon: "📱", label: "Products"          },
    { to: "/merge-duplicates",     icon: "🧹", label: "Merge Duplicates"  },
    { to: "/inventory",            icon: "🗃️",  label: "Inventory"         },
    { to: "/purchase",             icon: "🧾", label: "Purchase"          },
    { to: "/purchase-register",    icon: "📑", label: "Purchase Register" },
    { to: "/billing",              icon: "💳", label: "Billing"           },
  ]},
  { section: "Customers",  items: [
    { to: "/customers",            icon: "👤", label: "Customers"         },
    { to: "/customers/delete-requests", icon: "🗑️", label: "Delete Requests" },
    { to: "/returns",              icon: "↩️",  label: "Return Requests"   },
    { to: "/reviews",              icon: "⭐", label: "Reviews"           },
  ]},
  { section: "Catalog",    items: [
    { to: "/categories",           icon: "🗂️", label: "Categories"        },
    { to: "/brands",               icon: "🏷️", label: "Brands"            },
    { to: "/catalog/attributes",   icon: "🧩", label: "Attributes"        },
  ]},
  { section: "Home & CMS", items: [
    { to: "/home/sections",        icon: "🏠", label: "Home Sections"     },
    { to: "/home/banners",         icon: "🖼️", label: "Banners"           },
  ]},
  { section: "Marketing",  items: [
    { to: "/offers",               icon: "🎁", label: "Offers & Deals"    },
    { to: "/announcements",        icon: "📣", label: "Announcements"     },
    { to: "/notifications",        icon: "🔔", label: "Notifications"     },
  ]},
  { section: "Delivery",   items: [
    { to: "/delivery/pincodes",    icon: "🚚", label: "Delivery Charges"  },
    { to: "/settings/payments",    icon: "💳", label: "Payment Settings"  },
  ]},
  { section: "Settings",   items: [
    { to: "/settings/email-alerts",    icon: "📧", label: "Email Alerts"    },
    { to: "/settings/profile-schema",  icon: "🧩", label: "Profile Schema"  },
    { to: "/settings/account-sidebar", icon: "🧭", label: "Account Sidebar" },
  ]},
  { section: "Varaii Billing", items: [
    { to: "/licenses", icon: "🔑", label: "Licenses" },
  ]},
];

/* ── B2B Wholesale workspace menu ── */
const B2B_NAV = [
  { section: null, items: [
    { to: "/b2b/dashboard", icon: "📊", label: "B2B Dashboard" },
    { to: "/b2b/home",      icon: "🏠", label: "B2B Home"      },
    { to: "/b2b/buyers",    icon: "🏢", label: "B2B Buyers"    },
    { to: "/b2b/products",  icon: "📦", label: "B2B Products"  },
    { to: "/b2b/orders",    icon: "🧾", label: "B2B Orders"    },
    { to: "/b2b/notifications", icon: "🔔", label: "Notifications" },
  ]},
];

/* ── Seller (marketplace) workspace menu ── */
const SELLER_NAV = [
  { section: null, items: [
    { to: "/sellers/dashboard",     icon: "📊", label: "Dashboard"        },
    { to: "/sellers",               icon: "🏪", label: "Sellers"          },
    { to: "/sellers/products",      icon: "🔍", label: "Seller Products"  },
    { to: "/sellers/pending-edits", icon: "✏️", label: "Pending Changes"  },
    { to: "/sellers/listings",      icon: "🏬", label: "Seller Listings"  },
    { to: "/sellers/payouts",       icon: "💰", label: "Seller Payouts"   },
  ]},
];

export default function AdminSidebar() {
  const location = useLocation();
  const isB2B    = location.pathname.includes("/b2b");
  const isSeller = !isB2B && location.pathname.includes("/sellers");
  const NAV      = isB2B ? B2B_NAV : isSeller ? SELLER_NAV : RETAIL_NAV;
  const wsLabel  = isB2B ? "B2B Wholesale" : isSeller ? "Seller Hub" : "Admin Panel";
  const wsColor  = isB2B ? "#fbbf24" : isSeller ? "#34d399" : "#64748b";

  return (
    <div style={{
      width: 230, flexShrink: 0, background: "#0f172a", color: "white",
      position: "sticky", top: 0, alignSelf: "flex-start",
      height: "100vh", overflowY: "auto", padding: "0 10px 20px",
      display: "flex", flexDirection: "column",
      borderRight: "1px solid rgba(255,255,255,0.06)"
    }}>
      {/* Logo + workspace label */}
      <div style={{ padding: "22px 12px 18px", borderBottom: "1px solid rgba(255,255,255,0.07)", marginBottom: 8 }}>
        <div style={{ fontSize: 20, fontWeight: 900, color: "#fff", letterSpacing: -0.5 }}>
          VARAii
          <span style={{ fontSize: 11, fontWeight: 500, color: wsColor, display: "block", marginTop: 2 }}>
            {wsLabel}
          </span>
        </div>
      </div>

      {NAV.map(({ section, items }) => (
        <div key={section || "__top"}>
          {section && (
            <div style={{ fontSize: 10, fontWeight: 700, color: "#475569", letterSpacing: "0.08em", textTransform: "uppercase", margin: "12px 10px 4px" }}>
              {section}
            </div>
          )}
          {items.map(({ to, icon, label }) => (
            <NavLink key={to} to={`${ADMIN_PATH}${to}`} end={to === "/dashboard" || to === "/sellers" || to === "/sellers/dashboard"} style={({ isActive }) => ({
              display: "flex", alignItems: "center", gap: 10,
              padding: "9px 12px", marginBottom: 2, borderRadius: 10,
              textDecoration: "none", fontSize: 13, fontWeight: 600,
              background: isActive ? "rgba(99,102,241,0.18)" : "transparent",
              color: isActive ? "#818cf8" : "#94a3b8",
              transition: "all 0.15s",
            })}>
              <span style={{ fontSize: 15 }}>{icon}</span>
              {label}
            </NavLink>
          ))}
        </div>
      ))}
    </div>
  );
}
